module.exports = __webpack_public_path__ + "img/create-expression-filter.5e486dd0.png";